// src/components/Trades.tsx

import { TradesTable } from './trades_table';

export default function Trades() {
  return <TradesTable />;
}
